import { createAction } from '@/utility/actions';

import { SETTINGS_GET_DICTIONARY, SETTINGS_UPDATE_DICTIONARY } from './_types.ts';

export const getSettingsDictionary = createAction(SETTINGS_GET_DICTIONARY);

export const updateSettingsDictionary = createAction(SETTINGS_UPDATE_DICTIONARY);

export default {
  getSettingsDictionary,
  updateSettingsDictionary,
};
